/**
 * Хук для работы с уведомлениями через Redux
 * 
 * Отвечает за:
 * - Получение состояния уведомлений из Redux
 * - Предоставление методов для отправки, получения и удаления уведомлений
 */
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from './';
import {
    fetchNotifications,
    sendNotification,
    deleteNotification,
    NotificationPayload
} from '../slices/notificationsSlice';

export const useNotifications = () => {
    const dispatch = useAppDispatch();
    const {
        notifications,
        loading,
        submitting,
        error
    } = useAppSelector(state => state.notifications);

    const getNotifications = useCallback(() => {
        return dispatch(fetchNotifications());
    }, [dispatch]);

    const createNotification = useCallback(async (payload: NotificationPayload) => {
        const result = await dispatch(sendNotification(payload));
        // Refresh notifications list after creating a new notification
        await dispatch(fetchNotifications());
        return result;
    }, [dispatch]);

    const removeNotification = useCallback(async (id: number) => {
        const result = await dispatch(deleteNotification(id));
        // Refresh notifications list after deleting a notification
        await dispatch(fetchNotifications());
        return result;
    }, [dispatch]);

    return {
        notifications,
        loading,
        submitting,
        error,
        getNotifications,
        createNotification,
        removeNotification,
    };
}; 